import { render, staticRenderFns } from "./EditUserForm.vue?vue&type=template&id=61645892&scoped=true"
import script from "./EditUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditUserForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditUserForm.vue?vue&type=style&index=0&id=61645892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61645892",
  null
  
)

export default component.exports